import { render, staticRenderFns } from "./addFolder.vue?vue&type=template&id=bc3b7494"
import script from "./addFolder.vue?vue&type=script&lang=js"
export * from "./addFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports